import GreenStar from '@/assets/images/green-star.webp';
import { useDelayedUnmount } from '@/ui/hooks/useDelayedUnmount';
import { cn, formatCurrency } from '@/ui/lib/utils';
import { WIN_SCREEN_EXIT_DURATION } from '../useShowTimers';
import { useStore } from '@/store/useStore';
import './winScreen.css';

interface WinScreenProps {
    amount: number;
    show: boolean;
}

export const WinScreen = ({ show, amount }: WinScreenProps) => {
    const currency = useStore((state) => state.currency);
    const shouldRender = useDelayedUnmount(show, WIN_SCREEN_EXIT_DURATION);

    if (!shouldRender) return null;

    return (
        <div className={cn('win-screen', !show && 'win-screen--leaving')}>
            <div
                className="win-screen__container"
                style={
                    {
                        '--win-bg': `url(${GreenStar})`,
                    } as React.CSSProperties
                }
            >
                <div className="win-screen__content">
                    <h1 className="win-screen__title">BIG WIN!</h1>
                    <h2 className="win-screen__amount">{formatCurrency(amount, currency)}</h2>
                </div>
            </div>
        </div>
    );
};
